<template>
  <v-btn icon dark>
    <v-icon v-text="$vuetify.icons.values.search"></v-icon>
  </v-btn>
</template>

<script>
export default {}
</script>
